import React, { useEffect, useState } from 'react';
import FormSection from 'components/sales/formSection/formSection';
import localization from 'assets/localization/localization';
import Regex from 'services/utils/regex/Regex';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import TextAreaInput from 'components/sales/Input/textAreaInput/textAreaInput';
import { FormGroup } from 'react-bootstrap';
import TimePicker from 'react-times';
import { DatePickerInput } from 'rc-datepicker';
import 'react-times/css/classic/default.css';
import dateFormatReverse from 'constants/dateformatReverse';

const CampMomForm = ({ handleValue, meetingId, details = null, match }) => {
  const inputs = {
    camp_id: '',
    site_id: '',
    mom_date: '',
    mom_time: `${new Date().getHours()}:${new Date().getMinutes()}`,
    organiser_name: '',
    meeting_location: '',
    agenda: '',
    description: '',
    attendees: [],
  };
  const [formData, setData] = useState(inputs);
  const [attendees, setAttendees] = useState('');
  const [isFocus, setIsFocus] = useState(true);

  const handleMeetingData = () => {
    if (
      formData.mom_date !== '' &&
      formData.mom_time !== '' &&
      formData.organiser_name !== '' &&
      formData.meeting_location !== '' &&
      formData.attendees.length > 0 &&
      formData.description !== ''
    ) {
      /* Set camp_id from props */
      handleValue({
        ...formData,
        camp_id: meetingId,
        site_id: match?.params?.siteId,
      });
    } else handleValue(null);
  };

  useEffect(() => {
    handleMeetingData();
  }, [formData]);

  useEffect(() => {
    if (details !== null) {
      setData({
        ...formData,
        mom_date:
          (details?.camp?.scheduled_date &&
            dateFormatReverse(details?.camp?.scheduled_date)) ||
          new Date(),
        mom_time:
          details?.camp?.scheduled_time && details?.camp?.scheduled_time,
      });
    }
  }, [details]);

  function onChange(value) {
    const { hour, minute } = value;
    setData({ ...formData, mom_time: `${hour}:${minute}` });
  }

  const handleDateHide = () => {
    if (formData.mom_date) {
      setIsFocus(true);
    } else setIsFocus(false);
  };

  const handleDateChange = (date, dateString) => {
    setData({ ...formData, mom_date: dateString });
  };

  return (
    <FormSection title={localization.createMom}>
      <FormGroup
        className={`date custom_date_picker ${isFocus ? 'active-date' : ''}`}
      >
        <DatePickerInput
          value={formData.mom_date}
          onChange={handleDateChange}
          onShow={() => setIsFocus(true)}
          onHide={handleDateHide}
          onClear={() => setIsFocus(false)}
          autoClose
          closeOnClickOutside
          showOnInputClick
          locale="en"
          className="my-custom-datepicker-component"
          required
          displayFormat="DD-MM-YYYY"
          returnFormat="YYYY-MM-DD"
          minDate={new Date(formData.mom_date)}
        />
        <label>
          {localization.selectMomDate}
          <span className="label-star" style={{ color: 'red' }}>
            {' '}
            *{' '}
          </span>
        </label>
        {!isFocus && (
          <label className="error date_error">{localization.isRequired}</label>
        )}
      </FormGroup>

      <FormGroup>
        <TimePicker
          theme="classic"
          timeFormat="HH:MM"
          timeMode={24}
          time={formData?.mom_time}
          onTimeChange={onChange}
        />
        <label>
          {localization?.selectMomTime}
          <span className="label-star" style={{ color: 'red' }}>
            {' '}
            *{' '}
          </span>
        </label>
        <label className="error date_error">{localization?.isRequired}</label>
      </FormGroup>

      <ConstantInput
        value={formData?.organiser_name}
        label={localization?.meetingOrganisorName}
        regex={Regex?.text?.test(formData?.organiser_name)}
        errorMsg={localization?.meetingOrganisorRequired}
        type="text"
        required
        isStarRequired={true}
        handleChange={(val) => {
          setData({ ...formData, organiser_name: val });
        }}
      />

      <ConstantInput
        value={formData?.meeting_location}
        label={localization?.meetingLocation}
        regex={Regex?.text?.test(formData.meeting_location)}
        errorMsg={localization?.isRequired}
        type="text"
        required
        isStarRequired={true}
        handleChange={(val) => setData({ ...formData, meeting_location: val })}
      />

      <ConstantInput
        label={localization?.attendeesName}
        regex={Regex?.textWithComma?.test(attendees)}
        errorMsg={localization?.attendeesNameRequired}
        type="text"
        required
        isStarRequired={true}
        fullWidth
        handleChange={(val) => {
          setAttendees(val);
          const match = val.split(', ');
          setData({ ...formData, attendees: match });
        }}
      />
      <ConstantInput
        value={formData?.agenda}
        label={localization?.meetingAgenda}
        regex={Regex?.text?.test(formData.agenda)}
        errorMsg={localization.isRequired}
        type="text"
        fullWidth
        required
        isStarRequired={true}
        handleChange={(val) => setData({ ...formData, agenda: val })}
      />

      <TextAreaInput
        type="text"
        rows={4}
        required
        isStarRequired={true}
        className={`${
          !formData.description && 'empty'
        } inline-css scrollbar-styling`}
        value={formData?.description}
        inputValue={formData?.description}
        label={localization?.meetingDescription}
        errorMsg={localization?.meetingDescriptionRequired}
        handleChange={(e) =>
          setData({ ...formData, description: e.target.value })
        }
      />
    </FormSection>
  );
};

CampMomForm.propTypes = {};

export default CampMomForm;
